const PIXEL_ID = '1102870422081756';

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}

let initialized = false;

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return;
  initialized = true;

  if (!window.fbq) {
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq!.callMethod) {
        fbq!.callMethod(...args);
      } else {
        fbq!.queue!.push(args);
      }
    } as NonNullable<Window['fbq']>;

    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.push = fbq;

    window.fbq = fbq;
    window._fbq = fbq;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }

  window.fbq?.('init', PIXEL_ID);
  window.fbq?.('track', 'PageView');
}

export function trackAddToCart(params: {
  contentName: string;
  contentId?: string;
  value?: number;
}): void {
  if (typeof window === 'undefined') return;
  window.fbq?.('track', 'AddToCart', {
    content_name: params.contentName,
    content_ids: params.contentId ? [params.contentId] : undefined,
    content_type: 'product',
    value: params.value,
    currency: 'USD',
  });
}
